import BUNDLE_PROTECTIONPLAN_ON_CHANGE from '../actionTypes/BundleProtectionPlanActionTypes';

const selectBundleProtectionPlanAction = (payload) => ({
    type: BUNDLE_PROTECTIONPLAN_ON_CHANGE,
    payload,
    sourceMiniPDP: false,
});

export default selectBundleProtectionPlanAction;
